/**
 * Pelota, Petardos e Faísca (GDD, seção 2; item 4.2). Tempo de atordoamento e queda estão em `MATCH`. Distâncias em metros na escala do campo; os raios
 * seguem a escala de exibição dos atletas para a bola parecer do tamanho certo na mão.
 */
export const BALL = {
  pelota: {
    radius: 0.35,
    /** Gravidade da Pelota (m/s²): mais leve que a real, para a bola voar bonito em campo grande. */
    gravity: 7,
    dragPerSecond: 0.25,
    bounce: 0.55,
    groundFriction: 0.6,
    /** Distância a mais do corpo em que o atleta agarra a bola, pelo atributo Reflexo. */
    catchReach: { min: 0.5, max: 1.2 },
    /** Quem soltou a bola não a pega de volta logo em seguida (s). */
    regrabSeconds: 0.5,
    /** Posição da bola na mão: à frente e acima do centro do atleta. */
    holdForward: 1.1,
    holdUp: 0.7,
    passSpeed: { min: 20, max: 30 },
    /** Arremesso: velocidade sem carregar e com carga total, pelo atributo Arremesso. */
    throwSpeed: { min: 22, max: 38 },
    chargeSeconds: 1,
    /** Erro do passe e do arremesso, como fração da distância, do pior ao melhor atributo. */
    passError: { min: 0.09, max: 0.015 },
    throwError: { min: 0.12, max: 0.02 },
    /** Cone de mira (cosseno do ângulo máximo) e alcance para escolher companheiro ou aro. */
    aimCone: 0.5,
    passRange: 45,
    throwRange: 45,
    /** Choque mais forte que isto (m/s) solta a Pelota de quem carrega. */
    knockLooseImpact: 5,
  },
  petardo: {
    radius: 0.3,
    /** Velocidade de perseguição e aceleração de curva. */
    chaseSpeed: 15,
    chaseAcceleration: 14,
    /** Rebatida: velocidade pelo atributo Rebatida e tempo em linha reta antes de voltar a perseguir. */
    hitSpeed: { min: 26, max: 36 },
    launchedSeconds: 1.2,
    /** Depois de acertar alguém, o Petardo fica sem perseguir por um tempo e ignora essa vítima. */
    restSeconds: 1,
    ignoreVictimSeconds: 3,
    /** Alcance do taco do batedor (do centro do atleta). */
    batReach: 3.2,
    /** No começo da partida os Petardos esperam antes de caçar. */
    kickoffRestSeconds: 5,
  },
  faisca: {
    radius: 0.2,
    speed: 24,
    acceleration: 45,
    /** Foge de quem chega mais perto que isto. */
    fleeDistance: 12,
    /** Alcance da mão do caçador. */
    catchReach: 2.4,
    /** Troca de destino a cada tanto (s). */
    wanderSeconds: 2.5,
    minHeight: 5,
    maxHeight: 30,
  },
  /** Alcance da defesa do goleiro (soco na bola, fora da área). */
  keeperReach: 3.2,
  keeperPunchSpeed: 18,
} as const;
